import { Card, CardHeader, CardBody, Row, Col, Label, Input } from 'reactstrap';
import { ProductFormDetailsInterface } from 'types/productTypes';
import { useTranslation } from 'react-i18next';
import { Dispatch } from 'redux';
import { FieldArray, FormikProps } from 'formik';
import styles from 'pages/Products/styles/products.module.css';
import { Link } from 'react-router-dom';
import PopoverWithCloseButton from 'Components/pos2u/PopoverWithCloseButton';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import Cleave from 'cleave.js/react';
import { RiDeleteBin2Line } from 'react-icons/ri';

const ProductOptions = ({
  _isEdit,
  _dispatch,
  formik,
}: {
  _isEdit: boolean;
  _dispatch: Dispatch;
  formik: FormikProps<ProductFormDetailsInterface>;
}) => {
  const { t } = useTranslation();
  const productFormState = useSelector((state: RootState) => state.Product);
  const { showAllValidateErrors } = productFormState.form;
  const productOptionsInfo = `<p>คือ <strong>คุณสมบัติต่างๆ ที่ช่วยให้ร้านค้าเลือกสินค้าที่ตรงกับความต้องการได้</strong>ใช้สร้างตัวเลือกย่อยของสินค้า เช่น ขนาด สี หรือท็อปปิ้ง เพื่อให้ลูกค้าเลือกได้ตอนขายสินค้า
</p><p>สินค้าที่กำหนดตัวเลือกนี้ <strong>จะไม่ถูกตัดสต็อกตามแต่ละตัวเลือก</strong> — ระบบจะตัดสต็อกจากสินค้าหลักเท่านั้น</p>
<p><strong>ตัวอย่างการใช้งาน</strong></p>
      <ul class="list-unstyled">
        <li><strong>สี: </strong>เลือกสีที่ต้องการได้ เช่น แดง, น้ำเงิน, เขียว</li>
        <li><strong>ขนาด: </strong>เลือกขนาดที่เหมาะสมได้ เช่น S, M, L</li>
        <li><strong>วัสดุ: </strong>เลือกวัสดุที่ต้องการได้ เช่น ผ้าฝ้าย, ผ้าไหม</li>
        <li><strong>รุ่น: </strong>เลือกรุ่นหรือแบบย่อยของสินค้าได้ </li>

      </ul>
`;
  return (
    <Card>
      <CardHeader>
        <h5 className="card-title mb-0">{t('Product Options')}</h5>
      </CardHeader>
      <CardBody className={`${styles['card-body-pd']}`}>
        <Row>
          <Col lg={6}>
            <div className="d-flex align-items-flex-start py-0 mb-3">
              <Link
                to={'/product-option'}
                target="_blank"
                className="text-success"
                style={{ marginRight: '5px' }}
              >
                {t('Product Option Manager')}
              </Link>
              <PopoverWithCloseButton
                id="product-option-popover"
                data={{ title: t('Product Options'), body: productOptionsInfo }}
                icon="las la-question-circle"
              />
            </div>
          </Col>
          <Col lg={6}></Col>
        </Row>
        <Row>
          <Col lg={6}>
            <FieldArray
              name="productOptions"
              render={(_arrayHelpers) => (
                <>
                  {formik.values.productOptions.map((productOpt, index) => (
                    <div className="mb-3 row" key={index}>
                      <Row>
                        <Label className="col-sm-3 col-form-label d-flex align-items-flex-start py-0">
                          {t('Option')}
                        </Label>

                        <Col sm={6} xs={8}>
                          <div className="form-check form-switch form-switch-success">
                            <Label
                              className="form-check-label"
                              htmlFor={`switchCheck${index}`}
                            >
                              {productOpt.name}
                            </Label>
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id={`switchCheck${index}`}
                              name={`productOptions[${index}].selected`}
                              checked={productOpt.selected}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row
                        className={`mt-3 ${
                          !productOpt.selected ? 'd-none' : ''
                        }`}
                      >
                        <Col xs={0} sm={3}></Col>
                        <Col xs={12} sm={9}>
                          {/* <Col xs={0} sm={3} className="mb-2 mb-xs-0"></Col>
                        <Col xs={12} sm={9} className="mb-2 mb-xs-0"> */}
                          <Card className={styles['border-dashed']}>
                            <CardBody className={styles['card-body-pd']}>
                              <Row className="align-items-center mb-2 justify-content-center">
                                {/* <Col xs={6}> */}
                                <Col xs={6} sm={7} className="mb-2 mb-xs-0">
                                  <Label className={`${styles['text-pd']}`}>
                                    {t('Sub-option')}
                                  </Label>
                                  {/* <Label>{t('Sub-option')}</Label> */}
                                </Col>
                                {/* <Col xs={6}> */}
                                <Col xs={6} sm={5} className="mb-2 mb-xs-0">
                                  <Label>{t('Additional Price')}</Label>
                                </Col>
                              </Row>

                              <FieldArray
                                name={`productOptions[${index}].options`}
                                render={(optionHelpers) => (
                                  <>
                                    {productOpt.options.map(
                                      (option, optIdx) => (
                                        <Row
                                          key={optIdx}
                                          className="align-items-top mb-3 mb-xs-0 px-0 mx-0"
                                        >
                                          <Col
                                            xs={6}
                                            sm={6}
                                            className="mb-2 mb-xs-0"
                                          >
                                            <Input
                                              type="text"
                                              name={`productOptions[${index}].options[${optIdx}].name`}
                                              value={option.name}
                                              onChange={formik.handleChange}
                                              placeholder={t('Option_Name')}
                                              className="me-2"
                                              disabled
                                            />
                                          </Col>

                                          <Col
                                            xs={4}
                                            sm={4}
                                            className="mb-2 mb-xs-0"
                                          >
                                            <Cleave
                                              className="form-control"
                                              name={`productOptions[${index}].options[${optIdx}].value`}
                                              options={{
                                                numeral: true,
                                                numeralDecimalScale: 3,
                                                numeralIntegerScale: 13,
                                                numeralThousandsGroupStyle:
                                                  'thousand',
                                              }}
                                              value={option.value}
                                              onChange={(e: any) => {
                                                formik.setFieldValue(
                                                  `productOptions[${index}].options[${optIdx}].value`,
                                                  e.target.rawValue
                                                );
                                              }}
                                              onBlur={formik.handleBlur}
                                            />
                                            {(formik.touched.productOptions?.[
                                              index
                                            ]?.options?.[optIdx]?.value &&
                                              typeof formik.errors
                                                .productOptions?.[index] ===
                                                'object' &&
                                              'options' in
                                                formik.errors.productOptions[
                                                  index
                                                ] &&
                                              Array.isArray(
                                                formik.errors.productOptions[
                                                  index
                                                ].options
                                              ) &&
                                              typeof formik.errors
                                                .productOptions[index]
                                                .options?.[optIdx] ===
                                                'object' &&
                                              formik.errors.productOptions[
                                                index
                                              ].options?.[optIdx] !== null &&
                                              'value' in
                                                formik.errors.productOptions[
                                                  index
                                                ].options[optIdx] &&
                                              typeof formik.errors
                                                .productOptions[index].options[
                                                optIdx
                                              ].value === 'string') ||
                                            (showAllValidateErrors &&
                                              formik.isValid === false &&
                                              typeof formik.errors
                                                .productOptions?.[index] ===
                                                'object' &&
                                              'options' in
                                                formik.errors.productOptions[
                                                  index
                                                ] &&
                                              Array.isArray(
                                                formik.errors.productOptions[
                                                  index
                                                ].options
                                              ) &&
                                              typeof formik.errors
                                                .productOptions[index]
                                                .options?.[optIdx] ===
                                                'object' &&
                                              formik.errors.productOptions[
                                                index
                                              ].options?.[optIdx] !== null &&
                                              'value' in
                                                formik.errors.productOptions[
                                                  index
                                                ].options[optIdx] &&
                                              typeof formik.errors
                                                .productOptions[index].options[
                                                optIdx
                                              ].value === 'string') ? (
                                              <div className="text-danger">
                                                {
                                                  formik.errors.productOptions[
                                                    index
                                                  ].options[optIdx]
                                                    .value as string
                                                }
                                              </div>
                                            ) : null}
                                          </Col>

                                          <Col
                                            xs={2}
                                            sm={2}
                                            className="d-flex align-items-center mb-2 mb-xs-0"
                                            style={{
                                              padding: '0.5rem 0.9rem',
                                            }}
                                          >
                                            <div
                                              onClick={() =>
                                                optionHelpers.remove(optIdx)
                                              }
                                              role="button"
                                              tabIndex={0}
                                              // style={{
                                              //   display: 'flex',
                                              //   cursor: 'pointer',
                                              //   padding: '0',
                                              //   marginLeft: '8px',
                                              // }}
                                              // className="align-items-flex-start"
                                              style={{
                                                cursor: 'pointer',
                                                marginLeft: '8px',
                                              }}
                                              className="d-flex align-items-center justify-content-center"
                                            >
                                              <RiDeleteBin2Line
                                                color="red"
                                                size="20px"
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      )
                                    )}
                                  </>
                                )}
                              />
                              {(formik.touched.productOptions?.[index]
                                ?.options &&
                                typeof formik.errors.productOptions?.[index] ===
                                  'object' &&
                                typeof formik.errors.productOptions[index]
                                  .options === 'string') ||
                              (showAllValidateErrors &&
                                formik.isValid === false &&
                                typeof formik.errors.productOptions?.[index] ===
                                  'object' &&
                                typeof formik.errors.productOptions[index]
                                  .options === 'string') ? (
                                <div className="text-danger">
                                  {formik.errors.productOptions[index].options}
                                </div>
                              ) : null}
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </>
              )}
            />
          </Col>

          <Col lg={6}></Col>
        </Row>
      </CardBody>
    </Card>
  );
};
export default ProductOptions;
